import request from './request'

export const http = {
   //推送报价节点修改
   updateQuoteNodes(params) {
    return request({
        method: 'POST',
        url: '/platform/pc/platform/channel/updateQuoteNodes',
        data: params
    })
},
    //Q-推送报价节点列表
    getquoteNodesList(params) {
      return request({
        method: "GET",
        url: "/platform/pc/platform/channel/quoteNodes",
        params: params,
      });
    },
   //全量门店保存
   saveALLStore(params) {
    return request({
        method: 'POST',
        url: '/platform/pc/platform/channel/saveStore',
        data: params
    })
},
    //添加导入门店
    importAddStore(params) {
      return request({
          method: 'POST',
          url: '/platform/pc/platform/channel/importAddStore',
          data: params
      })
  },
      //导入全量门店
      importAllStore(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/platform/channel/importStore',
            data: params
        })
    },
   //外部门店数据导出
   outStoresExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/channel/outStoresExcel",
      data: params,
      responseType: "blob",
    });
  },
   //外部门店数据
   getoutStoresList(params) {
    return request({
        method: 'POST',
        url: '/platform/pc/platform/channel/outStores',
        data: params
    })
},
 //补充门店信息
 savestoreInformation(params) {
  return request({
      method: 'POST',
      url: '/platform/pc/platform/channel/storeInformation',
      data: params
  })
},
   //添加移除门店
   addandRemovechannelStore(params) {
    return request({
        method: 'POST',
        url: '/platform/pc/platform/channel/addStore',
        data: params
    })
},
   //Q-矩阵商户下拉
   getchannelmatrixCompanyList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/channel/matrixCompany",
      params: params,
    });
  },
     //添加门店列表
     getchannelstoreList(params) {
      return request({
          method: 'POST',
          url: '/platform/pc/platform/channel/storeList',
          data: params
      })
  },
      //Q-添加矩阵
      addMatrix(params) {
        return request({
          method: "GET",
          url: "/platform/pc/platform/channel/addMatrix",
          params: params,
        });
      },
     //已配置矩阵
     gethasMatrixList(params) {
      return request({
          method: 'POST',
          url: '/platform/pc/platform/channel/hasMatrixList',
          data: params
      })
  },
    //添加矩阵列表
    getaddMatrixList(params) {
      return request({
          method: 'POST',
          url: '/platform/pc/platform/channel/addMatrixList',
          data: params
      })
  },
     //Q-修改分发方式
     updateDispatcher(params) {
      return request({
        method: "GET",
        url: "/platform/pc/platform/channel/updateDispatcher",
        params: params,
      });
    },
    //Q-外部渠道
    getoutTypechannel(params) {
      return request({
        method: "GET",
        url: "/platform/pc/platform/channel/outType",
        params: params,
      });
    },
     //Q-分发矩阵配置
     getmatrixMasterchannel(params) {
      return request({
        method: "GET",
        url: "/platform/pc/platform/channel/matrixMaster",
        params: params,
      });
    },
    //是否限制本单继续追差
   setMatrixCode(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/matrix/save-fx-channel-code',
            data: params
        })
    },
    //列表
  aprchxList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/list",
      data: params,
    });
  },
  //导出Excel
  aprchxExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/excel",
      data: params,
      responseType: "blob",
    });
  },
  //Q-自动向外部提交渠道列表
  autoApplyChannelList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/channel/automaticConfigs",
      params,
    });
  },
  //启用-关闭 自动申请追差
  ocAutoApply(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/oc-auto-apply",
      data: params,
    });
  },
      //开启自动提交
  automaticSubmission(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/channel/automaticSubmission",
      data: params,
    });
  },
  //Q-详情
  detail(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/detail",
      data: params,
    });
  },
  //发起申请
  apply(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/apply",
      data: params,
    });
  },
  //追差分类列表
  aprCatalogList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/apr/catalog/list",
      data: params,
    });
  },
  //采货侠追差项
  down(params) {
    return request({
      method: "GET",
      url: "/platform/pc/apr/catalog/list/down",
      params: params,
    });
  },
  //平台追差项
  chxDownList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/apr/catalog/out/chx_down_list",
      params: params,
    });
  },
}